import { useState, useEffect } from "react";
import { cn } from "@/lib/utils";
import { Menu, X, MessageSquare } from "lucide-react";
import { Link } from "@tanstack/react-router";

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={cn(
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300 py-4 px-6 md:px-10",
        isScrolled
          ? "bg-white/80 backdrop-blur-md shadow-sm"
          : "bg-transparent",
      )}
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <a href="/" className="text-2xl font-bold text-primary">
          <MessageSquare className="h-6 w-6 text-primary" />
          aiEmailAgent<span className="text-blue-600">.</span>
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8">
          <a href="#features" className="nav-item">
            Features
          </a>
          <a href="#how-it-works" className="nav-item">
            How It Works
          </a>
          <a href="#pricing" className="nav-item">
            Pricing
          </a>
          <Link to="/blog" className="nav-item">
            Blog
          </Link>
          <a href="#contact" className="btn-outline ml-4">
            Contact
          </a>
          <Link
            to="/auth/login"
            className="btn-primary"
            search={{ redirectTo: "/dashboard" }}
          >
            Login
          </Link>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMenuOpen ? (
            <X className="w-6 h-6 text-primary" />
          ) : (
            <Menu className="w-6 h-6 text-primary" />
          )}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden absolute top-[72px] left-0 right-0 bg-white/95 backdrop-blur-md shadow-md animate-fade-down">
          <div className="flex flex-col p-6 space-y-4">
            <a
              href="#features"
              className="nav-item"
              onClick={() => setIsMenuOpen(false)}
            >
              Features
            </a>
            <a
              href="#how-it-works"
              className="nav-item"
              onClick={() => setIsMenuOpen(false)}
            >
              How It Works
            </a>
            <a
              href="#pricing"
              className="nav-item"
              onClick={() => setIsMenuOpen(false)}
            >
              Pricing
            </a>
            <Link
              to="/blog"
              className="nav-item"
              onClick={() => setIsMenuOpen(false)}
            >
              Blog
            </Link>
            <a
              href="#contact"
              className="btn-outline w-full text-center"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact
            </a>
            <Link
              to="/auth/login"
              className="btn-primary w-full text-center"
              onClick={() => setIsMenuOpen(false)}
              search={{ redirectTo: "/dashboard" }}
            >
              Get Started
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
